module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.indexLoaded) ? _c('div', {
    staticClass: "indexLoaded"
  }, [_c('h1', {
    staticClass: "headerElement"
  }, [_vm._v("Loading")])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "yearOuterWrapper"
    }
  }, _vm._l((_vm.gradyears), function(year, index) {
    return _c('div', {
      staticClass: "yearSingle",
      class: {
        slideOut: _vm.collapsed[index]
      },
      style: ({
        color: year.acf.yearcolor
      })
    }, [_c('div', {
      staticClass: "yearNavigation",
      style: ({
        'border-color': year.acf.yearcolor
      })
    }, [_c('div', [_vm._v(_vm._s(_vm.gradyears[index].slideoutactive))]), _vm._v(" "), _c('span', {
      staticClass: "left",
      on: {
        "click": function($event) {
          _vm.clickPrev(index)
        }
      }
    }, [_vm._v("← Past")]), _vm._v(" "), _c('span', {
      staticClass: "uppercase hoverYear",
      on: {
        "click": function($event) {
          _vm.clickCollapseAll(index)
        }
      }
    }, [_c('span', {
      staticClass: "ignoreTop"
    }, [_vm._v("Year"), _c('br', {
      staticClass: "tabletView"
    }), _vm._v(" " + _vm._s(year.name))])]), _vm._v(" "), _c('span', {
      staticClass: "right",
      on: {
        "click": function($event) {
          _vm.clickNext(index)
        }
      }
    }, [_vm._v("Future →")])]), _vm._v(" "), _c('Splashposts', {
      attrs: {
        "yearviewIndex": index,
        "yearColor": year.acf.yearcolor,
        "year": year.name,
        "listpostId": 'listPosts' + year.name,
        "categorylink": year._links['wp:post_type'][1].href
      }
    }), _vm._v(" "), _c('Listposts', {
      style: ({
        'background': year.acf.yearcolor
      }),
      attrs: {
        "yearview": index,
        "collapseAll": _vm.collapseAll,
        "yearColor": year.acf.yearcolor,
        "id": 'listPosts' + year.name,
        "indexGradyears": index,
        "categoryyear": year.name,
        "categorylink": year._links['wp:post_type'][2].href
      },
      on: {
        "stopIndexLoad": function($event) {
          _vm.stopIndexLoad()
        }
      }
    })], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e926a730!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Getgradyears.vue
// module id = 63
// module chunks = 1